import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { RouteObject } from 'react-router';

import SidebarLayout from 'src/layouts/SidebarLayout';
import BaseLayout from 'src/layouts/BaseLayout';

import SuspenseLoader from 'src/components/SuspenseLoader';
import ProtectedRoute from './ProtectedRoute';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

// Pages
const Login = Loader(lazy(() => import('src/pages/Login')));

const Home = Loader(lazy(() => import('src/pages/Home')))

const OrdersOverview = Loader(lazy(() => import('src/pages/Orders/OrdersOverview')));

const DoctorOverview = Loader(lazy(() => import('src/pages/Doctors/DoctorOverview')));

const PharmacyOverview = Loader(lazy(() => import('src/pages/Pharmacy/PharmacyOverview')));

const PatientsOverview = Loader(lazy(() => import('src/pages/Patients/PatientsOverview')));
const Account = Loader(lazy(() => import('src/pages/MyAccount/Account')));

const routes: RouteObject[] = [

  {
    path: '',
    element: <BaseLayout />,
    children: [
      {
        path: '/',
        element: <Login />
      }
    ]
  },
  {
    path: '',
    element: <ProtectedRoute />,
    children: [
      {
        path: '/home',
        element: <Home />
      }
    ]
  },
  // {
  //   path: '',
  //   element: <SidebarLayout />,
  //   children: [
  //     {
  //       path: '/home',
  //       element: <Home />
  //     }
  //   ]
  // },

  {
    path: '/patients',
    element: <ProtectedRoute />,
    children: [
      {
        path: '',
        element: <PatientsOverview />, // Parent with tabs
      },
    ],
  },

  {
    path: '/doctors',
    element: <ProtectedRoute />,
    children: [
      {
        path: '',
        element: <DoctorOverview />,
      }
    ]
  },

  {
    path: '/pharmacy',
    element: <ProtectedRoute />,
    children: [
      {
        path: '',
        element: <PharmacyOverview />,
      }
    ]
  },
  
  {
    path: '/orders',
    element: <ProtectedRoute />,
    children: [
      {
        path: '',
        element: <OrdersOverview />,
      }
    ]
  },
  
  {
    path: '',
    element: <ProtectedRoute />,
    children: [
      {
        path: '/doctors',
        element: <Home />
      }
    ]
  },

  {
    path: '',
    element: <ProtectedRoute />,
    children: [
      {
        path: '/account',
        element: <Account />
      }
    ]
  },
  
  {
    path: '',
    element: <BaseLayout />,
    children: [
    ]
  },
];

export default routes;
